import { render, staticRenderFns } from "./ResourceItemSelected.vue.js?vue&type=template&id=4ebefddc&scoped=true!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ResourceItemSelected.vue?vue&type=template&id=4ebefddc&scoped=true"
import script from "./ResourceItemSelected.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ResourceItemSelected.vue?vue&type=script&lang=js"
export * from "./ResourceItemSelected.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ResourceItemSelected.vue?vue&type=script&lang=js"
import style0 from "./ResourceItemSelected.vue.scss?vue&type=style&index=0&id=4ebefddc&prod&lang=scss&scoped=true!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ResourceItemSelected.vue?vue&type=style&index=0&id=4ebefddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebefddc",
  null
  
)

export default component.exports